export const clamp = (num: number, min: number, max: number) => Math.min(Math.max(num, min), max)

export const rate = (a?: number, b?: number) => {
  if (a === undefined && b === undefined) {
    return undefined
  }
  return ((a ?? 0) / (b || 1)).toFixed(2)
}

export const getFileType = (file: File | null) => {
  if (file?.type.startsWith('image/')) {
    return 'image'
  }
  if (file?.type.startsWith('video/')) {
    return 'video'
  }
  return null
}

export function hashCode(str: string) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  return hash
}

export function intToRGB(i: number) {
  const c = (i & 0x00FFFFFF)
    .toString(16)
    .toUpperCase()
  return '00000'.substring(0, 6 - c.length) + c
}

export function uid(): string {
  return (Date.now().toString(36) + Math.random().toString(36).substring(2, 12)).padStart(12, '0')
}
